import { Dispatch, SetStateAction, useEffect } from "react";
import { CLICK_OUTSIDE_SET_TIMEOUT_DURATION } from "../utils";

type useEscapeKeyProps = {
  setState: Dispatch<SetStateAction<boolean>> | ((state: boolean) => void);
  enableSetState?: boolean;
};

export const useEscapeKey = ({
  setState,
  enableSetState = true,
}: useEscapeKeyProps) => {
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;
      if (!enableSetState) return;
      setTimeout(() => setState(false), CLICK_OUTSIDE_SET_TIMEOUT_DURATION);
    };

    window.addEventListener("keydown", handleEscKey);
    return () => {
      window.removeEventListener("keydown", handleEscKey);
    };
  }, [enableSetState, setState]);
};
